import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ActivatedRoute } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { Title } from '@angular/platform-browser';
import { ProviderService as Service} from '../core/models/provider-service.model';
import { Provider } from '../core/models/provider.model';

import { ProviderService as ProviderService } from '../core/services/provider.service';
//import { NewCartService } from '../core/services/new-cart.service';

import { ServiceDetailService } from '../core/services/service-detail.service';

import { HttpClientModule } from '@angular/common/http';

import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CartService } from '../core/services/cart.service';
import { ProviderService as ProviderServiceModel } from '../core/models/provider-service.model';
import { MyBookingsService } from '../core/services/my-bookings.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.page.html',
  styleUrls: ['./category.page.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
  ],
  providers: [ServiceDetailService],
})
export class CategoryPage implements OnInit {
  service$: Observable<Service>;
  provider$: Observable<Provider>;
  currentFieldSlug: string | undefined;
  consultationService: ProviderServiceModel | undefined;
  consultation: Subscription | undefined;
  me2Subscribtion: Subscription;
  pastServices$: Observable<Map<string, any>>;
  loyaltySubscription: Subscription;

  constructor(
    private titleService: Title,
    private providerService: ProviderService,
    private route: ActivatedRoute,
    private serviceDetailService: ServiceDetailService,
    private myBookingsService: MyBookingsService,
    public cartService: CartService //public newCartService: NewCartService
  ) {
    const capitalizeFirstLetter = (text: string): string => {
      if (!text) return text;
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    };

    this.service$ = this.serviceDetailService
      .getServiceByPageRoute$(this.route.paramMap)
      .pipe(
        tap((category) => {
          this.titleService.setTitle(
            category?.name +
              ' | ' +
              capitalizeFirstLetter(category?.parentName) +
              ' | dm Studio'
          );
          this.currentFieldSlug = category.parentSlug;
          // console.info('this.currentFieldSlug', this.currentFieldSlug, category.parentSlug);

          const consultationSlug =
            this.currentFieldSlug == 'frizerske-storitve'
              ? 'brezplacno-frizersko-svetovanje'
              : 'brezplacno-svetovanje';
          // console.log('consultationSlug', consultationSlug);
          this.consultation = this.serviceDetailService
            .getServiceBySlug$(consultationSlug)
            .pipe(
              tap((service) => {
                // console.log('service', service);
                // this.consultationService = new ProviderServiceModel(service);
              })
            )
            .subscribe(); // Add this line to subscribe to the observable immediately
        })
      );

    this.provider$ = this.providerService.getProvider$();

    // console.log('this.currentFieldSlug', this.currentFieldSlug);
  }

  ngOnInit() {
    this.loyaltySubscription = this.myBookingsService.pastServices$.subscribe((services) => {
      console.log('past services', services);
    });

  }

  ionViewWillEnter() {
  }

  ngOnDestroy() {
    if (this.loyaltySubscription) {
      this.loyaltySubscription.unsubscribe();
    }
  }

  isDiscountAvailable(service: any): boolean {
    return (
      service?.regularPrice1 &&
      service?.minimalPrice?.lowestPrice &&
      service?.minimalPrice?.lowestPrice < service?.regularPrice1
    );
  }

  getHigherPrice(price: any): number {
    return +price + 2;
  }

  getServiceId(index: number, service: any) {
    return service.id;
  }
  hasVisibleServices(category): boolean {
    return (
      category &&
      category.children &&
      category.children.length > 0 &&
      category.children.some((service) => service.visibleForCustomers)
    );
  }

  hasSomeServices(category): boolean {
    return category.children.some((service) => service.length == 0);
  }
}
